module.exports = __webpack_public_path__ + "img/IMGP8634B.dbc85a68.jpg";